import { forwardRef } from 'preact/compat';
import { useProperties } from '../stores/ConfigStore';
import { useFormStore } from '../stores/FormStore';

const FormWindow = forwardRef(function FormWindow({ children, style = {} }, ref) {
	const { widthClass, screenshotActive, formWidth, formType, formOpen } = useFormStore();
	const { conversational, advanced } = useProperties();

	const divProps = {
		id: 'surveyWindow',
		className: `surveyWindow ${widthClass} ${advanced.formStyle ?? ''} ${
			screenshotActive ? 'screen-capture-active' : ''
		}`,
		'data-testid': formType,
		'data-state': formOpen ? 'open' : 'close',
		...(!formOpen && {
			'aria-hidden': 'true',
			inert: 'true'
		}),
		style: {
			width: formWidth || '100%',
			height: 'auto',
			maxHeight: '5000px',
			border: 'none',
			borderRadius: '3px',
			background: 'rgba(255,255,255,0.01)',
			transition: 'all .2s',
			overflow: 'hidden',
			...style,
			...(conversational && {
				transition: 'opacity .225s'
			})
		}
	};

	return (
		<div
			{...divProps}
			ref={ref}
		>
			{children}
		</div>
	);
});

export default FormWindow;
